// extracted by mini-css-extract-plugin
export default {"TextOverflow":"styles_TextOverflow__Xbmms","ReadMore":"styles_ReadMore__6ko30"};